<template>
  <section id="faqMarker">
    <h2 class="instH2">Ответы на вопросы</h2>
    <ul>
      <faqItem v-for="(item,index) in faq" v-bind:key="index" :item="item"></faqItem>
    </ul>
    <docLinkDesc :id="'instTxtDesc'"></docLinkDesc>
  </section>
</template>

<script>
export default {
  name: "faq",
  props: {
    ruStoreLink: {
      type: String,
      default() {
        return '';
      }
    },
    googleStoreLink: {
      type: String,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      // faq: [
      //   {
      //     title: 'Кто может получить заём?',
      //     desc: '<p>Заём может получить гражданин РФ в возрасте от 18 до 70 лет, который проживает <a href="https://lnd.msk.finmoll.com/admd/pdf/%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F%20%D0%BF%D1%80%D0%B8%D1%81%D1%83%D1%82%D1%81%D1%82%D0%B2%D0%B8%D1%8F.pdf" target="_blank">в зоне обслуживания</a> нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.</p>'
      //   }, {
      //     title: 'Как быстро проходит оформление?',
      //     desc: 'Авторизуйтесь через Госуслуги, чтобы ускорить процесс заполнения заявки, а также увеличить скорость и вероятность одобрения.'
      //   }, {
      //     title: 'Как я получу денежные средства?',
      //     desc: '<p>Компания предоставляет микрозаймы путем перечисления денежных средств на реквизиты Вашего банковского счета, указанные при оформлении договора.</p>'
      //   }, {
      //     title: 'Как быстро я получу денежные средства?',
      //     desc: '<p>Обычно денежные средства поступают в течение часа после подписания документов.</p>'
      //   }, {
      //     title: 'Как погасить заём?',
      //     desc: '<p>Любым удобным для Вас способом:</p><p>- через мобильное приложение <a :href="' + this.googleStoreLink + '">клиента «ФИНМОЛЛ»</a></p><p>- в сети салонов связи и в пунктах обслуживания сервиса «Золотая корона»</p><p>- в сети магазинов kari и kari KIDS</p><p>- Через сеть терминалов «Элекснет»</p><p>- банковской картой на сайте или в Личном кабинете клиента на сайте ООО МКК «ФИНМОЛЛ»</p><p>- банковским переводом по банковским реквизитам ООО МКК «ФИНМОЛЛ».</p><p>Для Вашего удобства Агент подскажет когда и какую сумму нужно внести.</p>'
      //   }, {
      //     title: 'Где скачать мобильное приложение клиента «ФИНМОЛЛ»?',
      //     desc: '<p>Мобильное приложение клиента «ФИНМОЛЛ» Вы можете найти в магазине приложений, соответствующему вашему мобильному устройству, Play Market или Rustore</p>'
      //   }
      // ]
    }
  },
  components: {
    faqItem: () => import('@/components/inst/design/faqItem.vue'),
    docLinkDesc: () => import('@/components/other/docLinkDescr.vue'),
  },
  computed: {
    faq(){
      return [
        {
          title: 'Кто может получить заём?',
          desc: '<p>Заём может получить гражданин РФ в возрасте от 18 до 70 лет, который проживает <a href="https://lnd.msk.finmoll.com/admd/pdf/%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F%20%D0%BF%D1%80%D0%B8%D1%81%D1%83%D1%82%D1%81%D1%82%D0%B2%D0%B8%D1%8F.pdf" target="_blank" class="faqDesca">в зоне обслуживания</a> нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.</p>'
        }, {
          title: 'Как быстро проходит оформление?',
          desc: 'Авторизуйтесь через Госуслуги, чтобы ускорить процесс заполнения заявки, а также увеличить скорость и вероятность одобрения.'
        }, {
          title: 'Как я получу денежные средства?',
          desc: '<p>Компания предоставляет микрозаймы путем перечисления денежных средств на реквизиты Вашего банковского счета, указанные при оформлении договора.</p>'
        }, {
          title: 'Как быстро я получу денежные средства?',
          desc: '<p>Обычно денежные средства поступают в течение часа после подписания документов.</p>'
        }, {
          title: 'Как погасить заём?',
          desc: '<p>Любым удобным для Вас способом:</p><p>- через мобильное приложение <a href="' + this.googleStoreLink + '" target="_blank" class="faqDesca">клиента «ФИНМОЛЛ»</a></p><p>- в сети салонов связи и в пунктах обслуживания сервиса «Золотая корона»</p><p>- в сети магазинов kari и kari KIDS</p><p>- через сеть терминалов «Элекснет»</p><p>- банковской картой на сайте или в Личном кабинете клиента на сайте ООО МКК «ФИНМОЛЛ»</p><p>- банковским переводом по банковским реквизитам ООО МКК «ФИНМОЛЛ».</p><p>Для Вашего удобства Агент подскажет когда и какую сумму нужно внести.</p>'
        }, {
          title: 'Где скачать мобильное приложение клиента «ФИНМОЛЛ»?',
          desc: '<p>Мобильное приложение клиента «ФИНМОЛЛ» Вы можете найти в магазине приложений, соответствующему вашему мобильному устройству, <a href="' + this.googleStoreLink + '" target="_blank" class="faqDesca">Play Market</a> или <a href="' + this.ruStoreLink + '" target="_blank" class="faqDesca">Rustore</a></p>'
        }
      ]
    }
  }
}
</script>

<style scoped>
ul {
  padding: var(--font-size-30) var(--font-size-21);
}

@media screen and (min-width: 760px) {
  ul {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: var(--font-size-30) 0;
  }
}
</style>